export class TokenRefreshedRecently extends Error {
    message = 'Authorization failed. Token already refreshed within request';
}

export class EmptyTokenError extends Error {
    message = 'Authorization failed. Empty token after refresh';
}
